const PreviousValue = ({
  children,
  previousValue,
  show = false,
  right = false,
  left = false,
  wide = false,
  header = "Poprzednia wartość:<hr/>",
  isNewProduct = false,
  className = "",
}) => {
  const previousValueHtml = header + previousValue;

  const shouldHighlight =
    (show && ![undefined, null, ""].includes(previousValue)) ||
    (show && isNewProduct);

  return (
    <div
      className={
        "position-relative " +
        (shouldHighlight ? "border border-danger rounded-3 " : "") +
        className
      }
    >
      <div>
        {children}
        {shouldHighlight && (
          <div
            className="tooltip position-absolute"
            style={{ top: "0.2em", right: "0.2em" }}
          >
            <span className="bi bi-clock-history text-danger fs-4 z-3" />
            <span
              className={
                "tooltiptext" +
                (wide ? " tooltip-500" : "") +
                (left ? " tooltip-top-left" : "") +
                (right ? " tooltip-top-right" : "") +
                " fs-6"
              }
              dangerouslySetInnerHTML={{ __html: previousValueHtml }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PreviousValue;
